<template>
  <b-navbar class="reports-nav">
    <b-nav-item
      class="report-item"
      :class="{ active: isSelected('reports') }"
      :active="isSelected('reports')"
      :title="labels.report"
      @click="selectReport('reports')"
    >
      <span :class="{ bold: isSelected('reports') }">
        {{ labels.report }}
      </span>
    </b-nav-item>
    <b-nav-item
      class="report-item"
      :class="{ active: isSelected('participation') }"
      :active="isSelected('participation')"
      :title="labels.participation"
      @click="selectReport('participation')"
    >
      <span :class="{ bold: isSelected('participation') }">
        {{ labels.participation }}
      </span>
    </b-nav-item>
    <b-nav-item
      v-if="hasFeedbacks"
      class="report-item"
      :class="{
        active:
          isSelected('feedbacks.tickets') ||
          isSelected('feedbacks.tickets.open'),
      }"
      :active="
        isSelected('feedbacks.tickets') || isSelected('feedbacks.tickets.open')
      "
      :title="labels.feedbacks"
      @click="selectReport('feedbacks.tickets')"
    >
      <span :class="{ bold: isSelected('feedbacks') }">
        {{ labels.feedbacks }}
      </span>
    </b-nav-item>
    <b-nav-item
      v-if="canSeeSettings"
      class="report-item"
      :class="{ active: isSelected('settings') }"
      :active="isSelected('settings')"
      :title="labels.settings"
      @click="selectReport('settings')"
    >
      <span :class="{ bold: isSelected('settings') }">
        {{ labels.settings }}
      </span>
    </b-nav-item>
  </b-navbar>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  selectedReport: {
    type: Number,
    default: 0,
  },
  canSeeSettings: {
    type: Boolean,
    default: false,
  },
  hasFeedbacks: {
    type: Boolean,
    default: false,
  },
}

export default {
  props,
  components: {},
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.component.customSurveys.reports.navbar
    },
  },
  methods: {
    isSelected(tab) {
      return this.$route.name === `custom-surveys.${tab}`
    },
    handleExportClick(type) {
      this.$emit('handleExportClick', type)
    },
    selectReport(tab) {
      this.$router.push({ name: `custom-surveys.${tab}` })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/breakpoints';

.reports-nav {
  z-index: 0;
  box-shadow: 0px 5px 3px rgba(61, 90, 254, 0.1);
  border: 1px solid var(--gray07) !important;
  border-radius: 10px !important;
  padding: 0px;
  margin-bottom: 20px;

  .report-item {
    height: 65px;
    width: 160px;
    display: flex;
    align-items: center;
    border-right: 1px solid map-get($theme-colors, 'gray07');

    @include media-breakpoint-down(sm) {
      font-size: 0.8rem !important;
    }

    .nav-link {
      width: 100%;
      text-align: center;
    }

    &:last-child {
      border-right: unset;
    }

    &.active {
      color: map-get($theme-colors, 'secondary');
      border-bottom: 5px solid map-get($theme-colors, 'secondary');
    }

    &.active:first-child {
      border-bottom-left-radius: 10px;
    }
  }
}
</style>
